import React from "react";

import { BarAndPieChart } from "../../../Components/Charts/BarAndPieChart/BarAndPieChart";

interface LocalBarAndPieChartData {
  title: string;
  value: number;
}

interface PayBillChartProps {
  data: any[];
}

const fieldLabelMapping: { [key: string]: string } = {
  "Navigate to Login": "Redirect to Account Login Page",
  "Navigate to Online Bill Pay Page": "Redirect to Bill Pay Page",
};

export const transformPayBillData = (rawData: any[]): LocalBarAndPieChartData[] => {
  const fields = ["Pay Bill Start", "Pay by Phone", "Pay Online", "Navigate to Login", "Navigate to Online Bill Pay Page"];

  const aggregatedData: { [key: string]: number } = {};

  rawData.forEach((item) => {
    fields.forEach((field) => {
      if (item[field]) {
        if (!aggregatedData[field]) {
          aggregatedData[field] = 0;
        }
        aggregatedData[field]++;
      }
    });
  });

  const payStart = aggregatedData["Pay Bill Start"] || 0;
  const payByPhone = aggregatedData["Pay by Phone"] || 0;
  const navToLogin = aggregatedData["Navigate to Login"] || 0;
  const navToBillPay = aggregatedData["Navigate to Online Bill Pay Page"] || 0;

  const noToRedirects = payStart - payByPhone - navToLogin - navToBillPay;
  if (noToRedirects > 0) {
    aggregatedData["No to Redirects"] = noToRedirects;
  }

  delete aggregatedData["Pay Bill Start"];
  delete aggregatedData["Pay Online"];

  return Object.keys(aggregatedData).map((key) => ({
    title: fieldLabelMapping[key] || key,
    value: aggregatedData[key],
  }));
};

export const PayBillChart: React.FC<PayBillChartProps> = ({ data }) => {
  const transformedData = transformPayBillData(data);
  return (
    <>
      <BarAndPieChart data={transformedData} showTotals={true} height={400} width={600} />
      <pre>{JSON.stringify(transformedData, null, 2)}</pre>
    </>
  );
};
